import RobotMaintenance from './index';

export default { path: '/home/robot/maintenance', component: RobotMaintenance };